<template>
  <BackButton @click="beb" />
  <div class="languages">
    <div class="language" id="RUB" @click="changeLanguage">
      <div class="firstLang">
        <img src="../assets/icons/ru.svg" />
        <p>Российский рубль</p>
        <p style="color: #808080">RUB, ₽</p>
      </div>
      <img class="galka" src="../assets/icons/galka.svg" v-if="currency == 'RUB'" />
    </div>
    <hr class="hrSetting" />
    <div class="language" id="UAH" @click="changeLanguage">
      <div class="firstLang">
        <img src="../assets/icons/ua.svg" />
        <p>Украинская гривна</p>
        <p style="color: #808080">UAH, ₴</p>
      </div>
      <img class="galka" src="../assets/icons/galka.svg" v-if="currency == 'UAH'" />
    </div>
    <hr class="hrSetting" />
    <div class="language" id="USD" @click="changeLanguage">
      <div class="firstLang">
        <img src="../assets/icons/usd.svg" />
        <p>Американский доллар</p>
        <p style="color: #808080">USD, $</p>
      </div>
      <img class="galka" src="../assets/icons/galka.svg" v-if="currency == 'USD'" />
    </div>
    <hr class="hrSetting" />
    <div class="language" id="KZT" @click="changeLanguage">
      <div class="firstLang">
        <img src="../assets/icons/kz.svg" />
        <p>Казахстанский тенге</p>
        <p style="color: #808080">KZT, ₸</p>
      </div>
      <img class="galka" src="../assets/icons/galka.svg" v-if="currency == 'KZT'" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { BackButton } from "vue-tg";
import { UserManager } from "@/utils/userManager";
export default {
  name: "SelectLanguage",
  data() {
    return {
      currency: this.$store.getters.getCurrency,
      user: null,
      botId: null,
    };
  },
  methods: {
    beb() {
      this.$emit("changeMode", "SelectCurrency");
    },
    async changeLanguage(event) {
      try {
        const response = await axios.post(`${window.location.origin}/user/set_currency/${this.botId}/${this.user.id}?currency=${event.target.closest("div .language").id}`);
        this.currency = event.target.closest("div .language").id;
        this.language = this.currency;
        console.log(response);
        this.$store.commit("setCurrency", this.currency);
      } catch (err) {
        console.log(err);
      }
    },
    initializeUser() {
      // Получаем данные пользователя из store или инициализируем заново
      const storedUser = this.$store.getters.getTgUserData;
      const storedBotId = this.$store.getters.getBotId;

      if (storedUser && storedBotId) {
        this.user = storedUser;
        this.botId = storedBotId;
        console.log("Данные пользователя из store:", this.user, this.botId);
      } else {
        const userContext = UserManager.getFullUserContext();
        this.user = userContext.user;
        this.botId = userContext.botId;
        this.$store.commit("setTgUserData", this.user);
        this.$store.commit("setBotId", this.botId);
        console.log("Новые данные пользователя:", this.user, this.botId);
      }
    },
  },
  mounted() {
    this.initializeUser();
  },
  setup() {
    return {};
  },
  components: { BackButton },
};
</script>

<style scoped>
.languages {
  background-color: var(--second-color);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  position: relative;
}
.language {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 17px;
  padding: 2.5%;
  transition: all 0.3s;
  cursor: pointer;
}
.language:active {
  scale: 0.97;
}
.firstLang {
  display: flex;
  gap: 10px;
  align-items: center;
}
.galka {
  width: 7vw;
}
.hrSetting {
  width: 85%;
  text-align: right;
  border: 0.5px solid var(--hr-color);
  margin: 0 auto;
  margin-right: 0;
}
</style>
